"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVRO_SCHEMA_KEY = exports.AVRO_CODEC_KEY = exports.AVRO_INIT_BYTES = exports.AVRO_SYNC_MARKER_SIZE = void 0;
exports.AVRO_SYNC_MARKER_SIZE = 16;
exports.AVRO_INIT_BYTES = new Uint8Array([79, 98, 106, 1]);
exports.AVRO_CODEC_KEY = "avro.codec";
exports.AVRO_SCHEMA_KEY = "avro.schema";
//# sourceMappingURL=AvroConstants.js.map